import {Component} from '@angular/core';
import {PageTitleComponent} from "../../components/page-title/page-title.component";
import {Button} from "primeng/button";
import {Location} from "@angular/common";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    Button
  ],
  templateUrl: './under-construction-page.component.html',
})
export class UnderConstructionPageComponent {
  constructor(private readonly location: Location) {
  }

  onClick() {
    this.location.back();
  }
}
